import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { TanStackQueryIds } from '../../query/query-ids'
import type { TagData } from '~~/src/api/tags'
import { setElementalTag } from '~~/src/api/tags'
import type { GetArg } from '~~/src/types/utils'

type FnType = typeof setElementalTag
type Args = GetArg<FnType>
type ReturnData = Awaited<ReturnType<FnType>>

export interface InsertElementalInATagArgs {elementalId: Args[0]; tagId: Args[1]; tag?: TagData}

export const useInsertElementalInATag = () => {
  const queryClient = useQueryClient()
  return useMutation<ReturnData, Error, InsertElementalInATagArgs>({
    mutationKey: ['set-elemental-tag'],
    mutationFn: async ({ elementalId, tagId }) => {
      return await setElementalTag(elementalId, tagId)
    },
    onMutate({ tagId, elementalId, tag }) {
      if (tag) {
        queryClient.setQueriesData<TagData[]>({
          queryKey: [TanStackQueryIds.ELEMENTAL_TAGS, elementalId],
          exact: false,
          type: 'all',
        }, (old) => {
          if (!old)
            return [tag]
          if (old.find(item => item.id === tagId))
            return old
          return [...old, tag]
        })
      }
    },
    onError: (_, { elementalId }) => {
      queryClient.refetchQueries({
        queryKey: [TanStackQueryIds.ELEMENTAL_TAGS, elementalId],
        exact: false,
        type: 'all',
      })
    },
  })
}
